var render = function render(){var _vm=this,_c=_vm._self._c;return _c('custom-drop-down',{staticClass:"dropdown__extended",attrs:{"fieldkey":"id","fieldname":"name","placeholder":_vm.placeholder,"clearable":false,"options":_vm.options},on:{"input":_vm.onChangeHandler},model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }